function makeInputChangeHandler(stateKeyPath, callback) {
  return newValue => {
    const newState = _.cloneDeep(this.state)
    _.set(newState, stateKeyPath, newValue)
    this.setState(newState)
    if (callback) { return callback(newValue) }
  }
}
export default { makeInputChangeHandler }


// WEBPACK FOOTER //
// ./src/scripts/mixins/MakeInputChangeHandler.js